import { mapCategories, mapSubCategories } from "./mapSportsbookCategories";
export function mapSportsbookSport(data) {
    return {
        id: data[0],
        seoIdentifier: data[1],
        name: data[2],
        sortOrder: data[3],
        categories: mapCategories(data[4]),
        subcategories: mapSubCategories(data[5])
    };
}
//# sourceMappingURL=mapSportsbookSport.js.map